import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ticket_interface } from 'src/core/interfaces/auth.interface';
import { ContactService } from 'src/services/contact/contact.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit , OnDestroy {

  form: FormGroup;

  
  constructor(
    private fb: FormBuilder,
    private service: ContactService
  ) { }

  ngOnInit(): void 
  {

    // create form
    this.create_form();

  }

  ngOnDestroy(): void 
  {
    this.form.reset();
  }

    
  
  create_form()
  {
    
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required , Validators.email]],
      title: ['', [Validators.required]],
      message: ['', [Validators.required]],
    });
    
    
  }
  


  
  mail_us()
  {


    if ( this.form.valid )
    {


      this.service.contact(this.form.value).subscribe(
        (data : any)=> {
          
          this.form.reset();
          alert("📨 Email sent successfully!");

        },
        (err)=> {
          alert("Faild to send email! please try again later!");
          console.error(err);
        }
      )   


    }
    else
    {
      alert("Something wrong happened! please try again later.");
    }

  }



}
